'use client'

import classNames from 'classnames'
import { FC, PropsWithChildren } from 'react'

export interface Props extends PropsWithChildren {
	bgColor?: string
	textColor?: string
	onClick?: () => void
}

const Badge: FC<Props> = ({
	bgColor = 'transparent',
	textColor = 'black',
	onClick,
	children,
}) => (
	<span
		className={classNames(`bg-${bgColor} text-${textColor}`, 'badge')}
		onClick={onClick}
	>
		{children}
	</span>
)

export default Badge
